import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { createTheme } from '@rtkwlf/ui';
import { ThemeProvider } from 'styled-components';
import { ROUTE_PATH, UUID_REGEX } from '../../../../../constants';
import { OnboardingScannerAddView } from './AddView';
import { OnboardingScannerEditView } from './EditView';
import { useFetchSiteSection } from '../../../hooks/useFetchSiteSection';
import { useFetchAvailableHardware } from '../../../hooks/useFetchAvailableHardware';
import { useFetchScannerSection } from '../../../hooks/useFetchScannerSection';

const theme = createTheme(
  {},
  {
    typographyLabelFontSize: '14px',
    typographyLabelTextTransform: 'none',
  },
);

export const OnboardingScannerRouteManager = () => {
  useFetchScannerSection();
  useFetchSiteSection();
  useFetchAvailableHardware();

  return (
    <ThemeProvider theme={theme}>
      <Switch>
        <Route
          exact
          path={ROUTE_PATH.ONBOARDING.SCANNERS.NEW}
          component={OnboardingScannerAddView}
        />

        <Route
          exact
          path={`${ROUTE_PATH.ONBOARDING.SCANNERS.EDIT}/:uuid(${UUID_REGEX})`}
          component={OnboardingScannerEditView}
        />

        <Redirect to={ROUTE_PATH.ONBOARDING.MAIN} />
      </Switch>
    </ThemeProvider>
  );
};
